import {mixins} from "../app/mixin";

var pagination = window.pagination;

mixins.push({
    el: '.cardDecksWrapper',
    data() {
        return {
            pagination: pagination
        }
    },
    methods: {
        nextPage(index) {
            if (this.pagination[index].currentPage < this.pagination[index].totalPages) {
                this.pagination[index].currentPage++;
                this.pagination[index].minIndex = (this.pagination[index].currentPage - 1) * this.pagination[index].postPerPage;
                this.pagination[index].maxIndex = ((this.pagination[index].currentPage - 1) * this.pagination[index].postPerPage) + this.pagination[index].postPerPage;
            }
        },
        prevPage(index) {
            if (this.pagination[index].currentPage > 1) {
                this.pagination[index].currentPage--;
                this.pagination[index].minIndex = (this.pagination[index].currentPage - 1) * this.pagination[index].postPerPage;
                this.pagination[index].maxIndex = ((this.pagination[index].currentPage - 1) * this.pagination[index].postPerPage) + this.pagination[index].postPerPage;
            }
        },
    }
});